const DEFAULT_REQUEST_TIMEOUT_MS = 10 * 1000;

function getRequestTimeoutMs() {
  const configuredValue = Number(process.env.REACT_APP_API_TIMEOUT_MS);

  if (Number.isFinite(configuredValue) && configuredValue >= 1000) {
    return configuredValue;
  }

  return DEFAULT_REQUEST_TIMEOUT_MS;
}

export async function fetchWithTimeout(url, options = {}) {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), getRequestTimeoutMs());

  try {
    return await fetch(url, {
      ...options,
      signal: controller.signal
    });
  } finally {
    clearTimeout(timeoutId);
  }
}
